export enum Enum_ReserveBy {
  branch = "branch",
  service = "service",
  doctor = "doctor"
}
